import React, { Component } from 'react';
import {Grid} from 'react-mdl';
import pdf from '../Documents/resume.pdf';

class Landing extends Component {
  render() {
    return(
      <div>
          <Grid className="landing-grid">
            <img
              src="http://donovanbuccat.com/Donovan-Buccat.jpg"
              style={{ maxHeight: '20%', maxWidth: '65%', minHeight: '40%', minWidth: '19%', marginBottom: '2%'}}
              alt="avatar"
              className="avatar-img"
              />

{/* LinkedIn */}

            <div
            className="banner-text-landing"
            >
              <h1>Software Engineer</h1>

            <hr/>

          <p>HTML/CSS | Python | JavaScript | React | Django | Java | ASP.NET | AWS</p>

        <div className="social-links">

          {/* LinkedIn */}
          <a href="https://www.linkedin.com/in/donovan-buccat" rel="noopener noreferrer" target="_blank" className="portfolio-button" style = {{ fontSize: '177%', marginLeft: '6%', textDecoration: 'none',color: 'white'}}> <p className ="SocialHeading">LinkedIn</p>
            <i className="fa fa-linkedin-square" aria-hidden="true" style = {{ fontSize: '130%', marginLeft: '5%'}}/>
          </a>

        {/* &ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp;&ensp; */}

          <a href = {pdf} rel="noopener noreferrer" target = {"_blank"} className="portfolio-button" style = {{ fontSize: '175%', marginLeft: '8%',textDecoration: 'none', color: 'white'}}> <p className ="SocialHeading"> Resume</p> <i className="fa fa-file" aria-hidden="true" style = {{color: 'white', fontSize: '100%', marginLeft: '5%'}}/> </a>


{/* */}



          {/* Github */}
          <a href="https://github.com/donovanbuccat" rel="noopener noreferrer" target="_blank" className="portfolio-button" style={{ marginLeft: '8%', fontSize: '177%', textDecoration: 'none',color: 'white'}}> <p className ="SocialHeading">GitHub</p>
            <i className="fa fa-github-square" aria-hidden="true" style = {{ fontSize: '130%', marginLeft: '5%'}}/>
          </a>

          {/* Facebook
          <a href="https://www.facebook.com/donovan.buccat" rel="noopener noreferrer" target="_blank" style={{ paddingLeft: '10%'}}>
            <i className="fa fa-facebook-square" aria-hidden="true" />
          </a>
          */}

          {/* Youtube
          <a href="https://youtube.com/channel/UC5TZg-1NPlyVcFDUpXC3gPQ" rel="noopener noreferrer" target="_blank" style={{ paddingLeft: '10%'}}>
            <i className="fa fa-youtube-square" aria-hidden="true" />
          </a>
          */}
        </div>
        </div>
        </Grid>
        </div>
    )
  }
}

export default Landing;
